import type { SocnaColorEnum } from '@e-socna/data-layer';

import { themeColorOf } from '../../../utils/theme-color-of.util';

import type { SpaceLevel } from '../enums/space-level.enum';

export interface ThemeColorSettings {
  readonly themeMainColor: SocnaColorEnum | null | undefined;
  readonly isContextualColorEnabled: boolean;
}

export type SpaceEmitterColors = Readonly<Partial<Record<SpaceLevel, string>>>;

const innermostColorOf = (
  spaceEmitterColors: SpaceEmitterColors,
): string | undefined =>
  Object.entries(spaceEmitterColors)
    .sort(([levelA], [levelB]) => Number(levelB) - Number(levelA))
    .map(([, color]) => color)
    .find(Boolean);

// The quotation emitter colour of the innermost space, else the user's colour, else the default.
export const resolveThemeMainColor = (
  { themeMainColor, isContextualColorEnabled }: ThemeColorSettings,
  spaceEmitterColors: SpaceEmitterColors,
): string => {
  const contextualColor = isContextualColorEnabled
    ? innermostColorOf(spaceEmitterColors)
    : undefined;

  return contextualColor ?? themeColorOf(themeMainColor).hex;
};
